module.exports = __webpack_public_path__ + "img/alibaba-cloud-logo.c8cda9c2.png";